import React from "react";
import { FieldRenderProps } from "react-final-form";

import styles from "./TextAreaInput.module.css";

type Props = FieldRenderProps<string, any>;

const TextAreaInput: React.FC<Props> = ({ input, meta, ...rest }: Props) => (
  <div className={styles.inputWrapper}>
    <textarea
      className={
        (meta.error || meta.submitError) && meta.touched
          ? styles.errorInputField
          : styles.inputField
      }
      {...input}
      {...rest}
    />
    {(meta.error || meta.submitError) && meta.touched && (
      <span className={styles.errorText}>{meta.error || meta.submitError}</span>
    )}
  </div>
);

export { TextAreaInput };
